export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

function toQuery(params) {
    if (!params) return "";
    const usp = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== "") usp.set(k, String(v));
    });
    const s = usp.toString();
    return s ? `?${s}` : "";
}

async function request(method, path, body, opts = {}) {
    const headers = {};
    const token = localStorage.getItem("jm_token");
    if (token) headers.Authorization = `Bearer ${token}`;
    let payload;
    if (body instanceof FormData) {
        payload = body;
    } else if (body !== undefined && body !== null) {
        headers["Content-Type"] = "application/json";
        payload = JSON.stringify(body);
    }
    const res = await fetch(API + path + toQuery(opts.params), { method, headers, body: payload });
    const text = await res.text();
    let data = null;
    try { data = text ? JSON.parse(text) : null; } catch { data = text; }
    if (!res.ok) {
        const err = new Error(typeof data?.detail === "string" ? data.detail : res.statusText);
        err.response = { status: res.status, data };
        throw err;
    }
    return { data, status: res.status };
}

export const api = {
    get: (p, opts) => request("GET", p, undefined, opts),
    post: (p, b, opts) => request("POST", p, b, opts),
    put: (p, b, opts) => request("PUT", p, b, opts),
    patch: (p, b, opts) => request("PATCH", p, b, opts),
    delete: (p, opts) => request("DELETE", p, undefined, opts),
};

export function apiErr(e, fallback = "Ocurrió un error") {
    const d = e?.response?.data?.detail;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
    return e?.message || fallback;
}

export function formatPrice(n) {
    return new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP", maximumFractionDigits: 0 }).format(n || 0);
}

export function imageUrl(src) {
    if (!src) return "";
    if (src.startsWith("http")) return src;
    if (src.startsWith("/api/")) return `${BACKEND_URL}${src}`;
    return src; // static /products/*.jpg
}

export const DEFAULT_TEXTS = {
    toast_added: "Agregado al carrito",
    toast_choose_variant: "Elegí talla y color antes de continuar",
    toast_soldout: "Producto agotado",
    toast_receipt_ok: "Comprobante recibido — estamos verificando tu pago",
    toast_order_cancelled: "Pedido cancelado",
    cart_empty_title: "Tu carrito está vacío",
    cart_empty_sub: "Explora la tienda y encuentra algo que te guste.",
};

export const TEXT_LABELS = {
    toast_added: "Mensaje al agregar al carrito",
    toast_choose_variant: "Aviso: falta elegir talla/color",
    toast_soldout: "Aviso: producto agotado",
    toast_receipt_ok: "Mensaje al subir comprobante",
    toast_order_cancelled: "Mensaje al cancelar pedido",
    cart_empty_title: "Carrito vacío (título)",
    cart_empty_sub: "Carrito vacío (subtítulo)",
};

export function uiText(settings, key) {
    const v = settings?.ui_texts?.[key];
    return (typeof v === "string" && v.trim()) ? v : (DEFAULT_TEXTS[key] || key);
}
